import { readCachedNotificationPreferences } from './notificationPreferences';

const STORAGE_KEY = 'preferredNotifyChannel';

export function setPreferredNotifyChannel(channel) {
  try {
    if (channel === 'whatsapp' || channel === 'sms' || channel === 'email') {
      localStorage.setItem(STORAGE_KEY, channel);
    }
  } catch (_e) {
    /* private mode */
  }
}

export function getPreferredNotifyChannel() {
  const cachedPrefs = readCachedNotificationPreferences();
  if (cachedPrefs) {
    if (cachedPrefs.whatsapp) return 'whatsapp';
    if (cachedPrefs.sms) return 'sms';
    if (cachedPrefs.email) return 'email';
    return undefined;
  }

  try {
    const value = localStorage.getItem(STORAGE_KEY);
    if (value === 'whatsapp' || value === 'sms' || value === 'email') return value;
  } catch (_e) {
    /* private mode */
  }

  return 'whatsapp';
}
